const SELECTOR = 'img[data-ch-early-load-image]:not([data-ch-early-load-hydrated])';
const DEFAULT_ROOT_MARGIN = '1800px 0px';

const observers = new Map();

function warmImage(image) {
  if (!(image instanceof HTMLImageElement) || image.dataset.chEarlyLoadWarmed === 'true') return;

  image.dataset.chEarlyLoadWarmed = 'true';
  image.loading = 'eager';
}

function getObserver(rootMargin) {
  if (observers.has(rootMargin)) return observers.get(rootMargin);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        observer.unobserve(entry.target);
        warmImage(entry.target);
      });
    },
    { rootMargin },
  );

  observers.set(rootMargin, observer);
  return observer;
}

function hydrateEarlyImages(root = document) {
  root.querySelectorAll?.(SELECTOR).forEach((image) => {
    if (!(image instanceof HTMLImageElement)) return;

    image.dataset.chEarlyLoadHydrated = 'true';

    if (!('IntersectionObserver' in window)) {
      warmImage(image);
      return;
    }

    const rootMargin = image.dataset.chEarlyLoadRootMargin || DEFAULT_ROOT_MARGIN;
    getObserver(rootMargin).observe(image);
  });
}

hydrateEarlyImages();

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof Element)) return;
  hydrateEarlyImages(event.target);
});
